import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import LiveSports from "@features/offer/desktop/view/LiveVirtualizedOffer";
import LiveEmptyOfferMessage from "@features/offer/desktop/view/live-virtualized-offer-components/LiveEmptyOfferMessage";
import LiveSkeletonLoader from "@features/offer/desktop/view/live-virtualized-offer-components/LiveSkeletonLoader";
import LiveViewStore from "@state/stores/offer/live/LiveViewStore";
import { THEME_SETTINGS } from "@theme-settings";
import { observer } from "mobx-react";

import { RemoveAllFavoritesButton } from ".";

export const LivePageTemplateCore = observer(
	function LivePageTemplateCore(props: { store: LiveViewStore }) {
		const t = useTranslation().t;

		useEffect(() => {
			//on mount scroll to top
			window.scrollTo(0, 0);
		}, []);

		if (props.store.isLoading) {
			return <LiveSkeletonLoader />;
		}

		if (props.store.isEmpty) {
			return <LiveEmptyOfferMessage period={props.store.period} />;
		}

		return (
			<>
				<div className="l--content__main u-padd--top">
					{THEME_SETTINGS.features.isGroupByTournamentEnabled && (
						<div className="card card--shadowy">
							<div className="u-display--f u-display--f--center u-gap--sml">
								<label
									htmlFor="group-by-tournament"
									onClick={(ev) => ev.preventDefault()}
									className="u-display--f--grow u-type--sml"
								>
									{t("LIVE.GROUP_BY_TOURNAMENT")}
								</label>

								<div className="toggle">
									<input
										id="group-by-tournament"
										type="checkbox"
										checked={
											props.store.isGroupedByTournament
										}
										className="toggle__input"
										onChange={(e) =>
											props.store.setIsLiveOfferGrouped(
												!props.store
													.isGroupedByTournament
											)
										}
									/>
									<label
										htmlFor="group-by-tournament"
										className="toggle__handle"
									/>
								</div>
							</div>
						</div>
					)}
					<LiveSports store={props.store} />
					<RemoveAllFavoritesButton />
				</div>
			</>
		);
	}
);
